import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { useSubscription } from "@/context/SubscriptionContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CircleNotch, IdentificationCard, PencilSimple } from "@phosphor-icons/react";
import { toast } from "sonner";

const FIELDS = [
  ["name", "Nome do titular", "text"],
  ["address", "Morada", "text"],
  ["phone", "Telefone", "tel"],
  ["email", "Email", "email"],
];

export function HolderDetails({ canEdit }) {
  const { holder, holder_complete: complete, refresh } = useSubscription();
  const [form, setForm] = useState(holder || {});
  const [editing, setEditing] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setForm(holder || {}); }, [holder]);
  const open = editing || !complete;

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put("/plan/holder", form);
      await refresh();
      setEditing(false);
      toast.success("Dados do titular guardados");
    } catch (err) { toast.error(apiError(err)); }
    setBusy(false);
  };

  return (
    <section id="holder-details" className={`rounded-2xl border p-5 ${complete ? "border-border bg-card" : "border-2 border-warn bg-amber-50/60"}`} data-testid="holder-details">
      <div className="flex items-center justify-between gap-3">
        <h2 className="flex items-center gap-2 font-display text-lg font-bold"><IdentificationCard size={22} className="text-primary" /> Dados do titular</h2>
        {complete && !editing && canEdit && (
          <Button variant="ghost" size="sm" onClick={() => setEditing(true)} data-testid="holder-edit-btn"><PencilSimple size={15} className="mr-1" /> Editar</Button>
        )}
      </div>
      {!open ? (
        <p className="mt-2 text-sm text-muted-foreground" data-testid="holder-summary">{holder.name} · {holder.address} · {holder.phone} · {holder.email}</p>
      ) : (
        <form onSubmit={save} className="mt-3 space-y-3" data-testid="holder-form">
          {!complete && <p className="text-sm" data-testid="holder-required-note">Obrigatório antes de pagar: nome, morada, telefone e email do titular.</p>}
          <div className="grid gap-3 md:grid-cols-2">
            {FIELDS.map(([k, label, type]) => (
              <div key={k} className="space-y-1.5">
                <Label htmlFor={`holder-${k}`}>{label}</Label>
                <Input id={`holder-${k}`} type={type} required minLength={k === "name" ? 2 : 3} disabled={!canEdit} value={form[k] || ""}
                  onChange={(e) => setForm({ ...form, [k]: e.target.value })} data-testid={`holder-${k}`} />
              </div>
            ))}
          </div>
          {canEdit && (
            <div className="flex gap-2">
              <Button type="submit" className="rounded-full" disabled={busy} data-testid="holder-save-btn">{busy ? <CircleNotch className="animate-spin" /> : "Guardar dados"}</Button>
              {complete && <Button type="button" variant="outline" className="rounded-full" onClick={() => { setForm(holder); setEditing(false); }}>Cancelar</Button>}
            </div>
          )}
        </form>
      )}
    </section>
  );
}
